
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class StageBaseController {
    constructor($log, $state, $Forms, Dialog, Session, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$Forms = $Forms;
        this.Dialog = Dialog;
        this.Session = Session;
        this.Trophies = Trophies;
    }

    $onInit(){
        $('body .stage-container').addClass('stage-bg-2');
    }
        
    $onDestroy(){
        $('body .stage-container').removeClass('stage-bg-2');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-base.controller.js